<template>
  <div class="photo-holder">
    <div class="photo" @click="pickPhoto()">
      <img
        :src="photoSrc"
        alt="">
    </div>
    <input type="file" style="display:none;" ref="photoInput" @change="setPhoto()">
  </div>
</template>
<script>

  export default {
    props: ['initialPhoto'],
    data() {
      return {
        photo: null,
        photoChanged: false,
      }
    },
    computed: {
      photoSrc() {
        if (this.photo) {
          return this.photo
        } else if (this.initialPhoto) {
          return this.initialPhoto
        }
        return process.env.BASE_URL + '/default-user.png'
      }
    },
    methods: {
      pickPhoto() {
        this.$refs.photoInput.click()
      },
      setPhoto() {
        this.photoChanged = true;

        let input = this.$refs.photoInput;
        let file = input.files[0]
        let reader = new FileReader();

        reader.onloadend = () => {
          this.photo = reader.result;
        }

        if (file) {
          reader.readAsDataURL(file);
        }
      },
      submit(user_id) {
        if (!this.photoChanged) {
          return;
        }
        const photo = this.$refs.photoInput.files[0]
        let formData = new FormData();
        formData.append("photo", photo);
        this.axios.post('users/updatePhoto/' + user_id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          if (response.status === 202) {
            this.photo = null
            this.$emit('photoUpdated', response.data)
            this.photoChanged = false
          }
        }).catch(error => {})
      }
    }
  }
</script>
<style lang="scss" scoped>
  .photo {
    width: 75px;
    height: 75px;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/users/PhotoUplaod.vue